import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';

const SocketContext = createContext();

export const useSocket = () => {
    return useContext(SocketContext);
};

export const SocketProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);

    useEffect(() => {
        const newSocket = io(`${process.env.REACT_APP_SERVER}`);
        setSocket(newSocket);

        newSocket.on('connect', () => {
            console.log('Global Socket Connected');
            const currentUser = JSON.parse(localStorage.getItem('user'));
            if (currentUser) {
                newSocket.emit('registerUser', currentUser._id);
            }
        });

        return () => newSocket.close();
    }, []);

    return (
        <SocketContext.Provider value={socket}>
            {children}
        </SocketContext.Provider>
    );
};
